export const CINEMATIC_HERO_CONTAINER_ID = 'cinematic-hero-container'
